import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "h-5 w-5 flex items-center justify-center" }
const _hoisted_3 = ["disabled"]

import { UiInput, SvgIcon, useForm } from '@/ui-kit';
import {
	required,
	minLength,
	maxLength
} from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageSample',
  props: {
    canDelete: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
	canDelete: boolean;
	disabled: boolean;
	modelValue: string;
	index: number;
};





const { formData } = useForm(
	{
		value: props.modelValue
	},
	{
		value: {
			required,
			minLength: minLength(20),
			maxLength: maxLength(1024)
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiInput), {
      disabled: __props.disabled,
      class: "w-full",
      type: "textarea",
      modelValue: _unref(formData).value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).value) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (
				_ctx.$emit('update:modelValue', $event)
			))
      ],
      name: `message_samples.${__props.index + 1}`
    }, null, 8, ["disabled", "modelValue", "name"]),
    _createElementVNode("div", _hoisted_2, [
      (__props.canDelete && !__props.disabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            disabled: __props.disabled,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('removeItem')))
          }, [
            _createVNode(_unref(SvgIcon), {
              class: "mt-14 h-5 w-5",
              name: "delete"
            })
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})